export const init = () => {
  if (document.querySelector('.js-video-touch')) {
    const allVideos = document.querySelectorAll('.js-video-touch');

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const onIntersection = (entries, observer) => {
      entries.forEach(entry => {
        const videoContainer = entry.target;
        const video = videoContainer.querySelector('video');

        if (!video) return;

        if (entry.isIntersecting) {
          const source = video.querySelector('source[data-src]');
          if (source && !source.src) {
            source.src = source.dataset.src;
            video.load();
          }
          video.play().catch(() => {
            console.warn("Video failed");
          });
        } else {
          video.pause();
        }
      });
    };

    const observer = new IntersectionObserver(onIntersection, options);

    allVideos.forEach(videoContainer => {
      observer.observe(videoContainer);
    });
  }
}
